var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsoAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55703 0.500656C0.296127 2.86717 -2.56148 13.0886 2.55308 19.7963L5.08717 17.9209C-0.527514 10.5919 6.90975 0.255755 15.5896 4.14453C21.0392 6.58452 22.3669 13.3477 18.7011 17.9325C19.3262 18.265 20.3754 19.331 20.9155 19.5733C21.0792 19.6468 21.2004 19.7138 21.3615 19.5797C28.4791 10.4192 19.8547 -2.73462 8.55703 0.500656Z",
    fill: "#285171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5074 20.0346C15.0894 17.7171 19.7555 15.4331 18.0347 10.209C15.9298 3.81961 6.09513 4.7773 5.55506 11.6796C5.43647 13.1903 6.1338 15.5774 7.37506 16.49L9.71451 14.9459C5.64013 11.1022 12.0424 6.01728 14.9167 10.343C16.439 12.6348 14.7247 14.487 12.9588 15.8004C10.2881 17.7854 7.16109 19.2793 4.49167 21.2927C4.38727 21.446 6.72672 22.9258 7.07731 22.9013C8.27733 22.1124 9.45543 21.2901 10.6683 20.5206C10.8217 20.4226 11.2664 20.1906 11.5062 20.0359",
    fill: "#285171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0752 23.7869C10.4142 23.9223 12.1337 24.1981 14.379 23.7895C16.0804 23.4802 17.497 22.8318 19.3544 21.5274L16.9582 19.3774L10.0765 23.7869H10.0752Z",
    fill: "#285171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoAzul);
export default __webpack_public_path__ + "static/media/iso_azul.b22cf78bf5dc09d80bf1a0def678b923.svg";
export { ForwardRef as ReactComponent };